import styled from 'styled-components'
import Flex from 'components/Flex'
import { COLORS } from 'theme'
import { FONT } from 'theme/font'
export const LeftDiv = styled.div`
  width: 100%;
`
export const StickyDiv = styled.div`
  position: sticky;
  top: 120px;
  margin: 20px 0;
`

export const Container = styled(Flex)`
  padding: 15px 0;
`
export const StepsFlex = styled(Flex)`
  padding-right: 66px;
  width: 100%;
`
export const StepRoundFlex = styled(Flex)`
  gap: 4px;
`

export const RoundDiv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_500};
  font-size: ${FONT.F_XS};
  line-height: 15px;
  color: ${COLORS.GREY_T_60};
`
export const Titlediv = styled.div`
  font-style: normal;
  font-weight: ${FONT.FW_600};
  font-size: ${FONT.F_BASE};
  line-height: 21px;
  color: ${COLORS.GREY_T_20};
  margin: 0 0 10px 0;
  text-transform: capitalize;
`
export const ArrowIconDiv = styled.div``

export const EmptyTextWrape = styled(Flex)`
  padding: 50px;
  font-weight: 600;
  font-size: 16px;
  color: #676e83;
`
export const ShortListButton = styled.div`
  font-weight: 700;
  color: #5DB594;
  border: 1px solid #BEE1D4;
  background: #BEE1D4;
  height: 25px;
  border-radius: 6px;
  position: absolute;
  bottom: 10px;
  right: 46px;
  padding-left:10px;
  padding-right:10px;
`
